import ImportantInfo from "../components/ImportantInfo";
import Paragraph from "../components/common/Paragraph";
import Title from "../components/common/Title";
import NewsArchive from "../components/news/NewsArchive";
import NewsEntry from "../components/news/NewsEntry";
import news, { newsArchive2025 } from "../config/news";
import { useTitle } from "../hooks/useTitle";

export default function News() {
  useTitle("News und Aktionen");

  return (
    <>
      <section id={"news"} className={"py-12 lg:py-24"}>
        <Title>Unsere News & Aktionen</Title>

        {news.length <= 0 ? (
          <Paragraph
            data-aos={"fade-right"}
            data-aos-duration={600}
            data-aos-delay={100}
          >
            Zur Zeit gibt es keine News oder Aktionen
          </Paragraph>
        ) : null}
        <div
          className={
            "flex flex-col mt-5 lg:mt-24 md:gap-16 px-4 lg:px-24 gap-12"
          }
        >
          {news.map((newsItem, index) => {
            return <NewsEntry news={newsItem} index={index} key={index} />;
          })}
        </div>

        <div className="mt-8 lg:mt-16 px-4 lg:px-24">
          <NewsArchive year="2025" items={newsArchive2025} />
        </div>
      </section>

      <div className={"mb-4 lg:mb-24"}>
        <ImportantInfo />
      </div>
    </>
  );
}
